import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ReviewPeriodForm from "@/modules/performance/admin/components/review-period/ReviewPeriodForm";

export const Route = createFileRoute(
  "/admin/_panel/_performance/performance/reviews/periods/create",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "performance.performance-review-period.create",
    );
    return {
      crumb: [
        {
          label: context.t("Create Performance Management Cycle", {
            ns: "performance.admin",
          }),
        },
      ],
    } satisfies ChildRouteContext;
  },
});

function RouteComponent() {
  const { t } = useTranslation("performance.admin");
  return (
    <Container
      title={t("Create Performance Management Cycle")}
      description={t(
        "With this section, you can create a performance management cycle for users.",
      )}
      className="flex h-full flex-col"
    >
      <ReviewPeriodForm />
    </Container>
  );
}
